    
import React from "react";
import { ResultItem } from '.'

function ResultItemList(props) {
  return (
      <ul className="list-group list-group-flush">
          {
              props.Items
              && props.Items.map((c, i) => <ResultItem id={i} title={c.Title} path={c.Path} info={c.Info} iconchecker={ c.IconCheckers } key={i}></ResultItem>)
        }
      </ul>
  );
}

export default ResultItemList;